import { render, staticRenderFns } from "./bodyRightTop.vue?vue&type=template&id=4a34d79d&scoped=true"
import script from "./bodyRightTop.vue?vue&type=script&lang=js"
export * from "./bodyRightTop.vue?vue&type=script&lang=js"
import style0 from "./bodyRightTop.vue?vue&type=style&index=0&id=4a34d79d&prod&lang=scss&scoped=true"
import style1 from "./bodyRightTop.vue?vue&type=style&index=1&id=4a34d79d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a34d79d",
  null
  
)

export default component.exports